import { defineMessages } from 'react-intl';

export default defineMessages({
  findDealer: {
    id: 'components.ProductLayout.findDealer',
    defaultMessage: 'Find a Dealer',
  },
  buyAtLocalDealer: {
    id: 'components.ProductLayout.buyAtLocalDealer',
    defaultMessage: 'Buy {productName} at your local dealer: Find a dealer',
  },
});
